import React from 'react';
import moment from 'moment';
import { TableComponent, connect } from '../tableComponent';
import { parseNumber } from '../../helpers';

class Component extends TableComponent {
  offers = [
    { name: 'Cupid3', value: 'loc' },
    { name: 'All', value: 'all' },
    { name: 'HLinks', value: 'chatsales' },
    { name: 'Loans', value: 'hgh2' },
    { name: 'H1', value: 'hg1' },
    { name: 'A', value: 'andy' },
    { name: 'A3', value: 'andy30' },
    { name: 'A6', value: 'andy60' },
    { name: 'Hookupbay', value: 'hookupbay' },
    { name: 'KLinks', value: 'chrissales' },
    { name: 'EasySX', value: 'easysex' },
    { name: 'IFramecash', value: 'sexplaycam' },
    { name: 'Livecam', value: 'imlive' },
    { name: 'CeVIP', value: 'cevip' },
    { name: 'Wellhello', value: 'wellhello' },
    { name: 'SandraCams', value: 'sandra_sales' },
    { name: 'Cupid', value: 'cupid' },
    { name: 'CPS', value: 'andy1' },
    { name: 'DGold', value: 'dgold' },
    { name: 'PunkBank', value: 'punk' },
    { name: 'PunkBank1', value: 'punk1' },
    { name: 'SLinks', value: 'sms' }
  ];

  initialState = {
    type: 'daily',
    affiliate: '',
    from: moment().subtract(1, 'months'),
    to: moment(),
    offer: 'loc'
  };

  makeColumns = () => {
    const columns = [
      {
        Header: 'Date',
        id: 'date2',
        accessor: (d) => parseInt(d.date2),
        minWidth: 120,
        className: 'text-center',
        Cell: (props) => <span>{props.original.date}</span>
        // sortable: false
      },
      {
        Header: 'Unique',
        id: 'uniq_visits',
        accessor: (d) => parseInt(d.uniq_visits) || 0,
        className: 'text-center',
        minWidth: 100,
        // sortable: false,
        Footer: (props) => <span>{this.props.total.uniq_visits || 0}</span>
      },
      {
        Header: 'Signups',
        id: 'signups',
        accessor: (d) => parseInt(d.signups) || 0,
        minWidth: 50,
        sortable: false,
        className: 'text-center',
        Footer: (props) => <span>{this.props.total.signups || 0}</span>
      },
      {
        Header: 'Flagged',
        id: 'fraud',
        accessor: (d) => parseInt(d.fraud) || 0,
        minWidth: 50,
        sortable: false,
        className: 'text-center',
        Footer: (props) => <span>{this.props.total.fraud || 0}</span>
      },
      {
        Header: 'Sales',
        id: 'total_sales',
        accessor: (d) => parseInt(d.total_sales) || 0,
        className: 'text-center',
        minWidth: 60,
        // sortable: false,
        Footer: (props) => <span>{this.props.total.sales || 0}</span>
      },
      {
        Header: 'Earned',
        id: 'total_dollars',
        accessor: (d) => parseNumber(d.total_dollars) || 0,
        minWidth: 60,
        className: 'text-center',
        // sortable: false,
        Cell: (props) => (
          <div>
            $
            {this.props.user.role_id == 0
              ? (props.original.total_sales || 0) * this.props.user.chatsales_earnings
              : props.value}
          </div>
        ),
        Footer: (props) => <div>${this.props.total.total_dollars || 0}</div>
      }
    ];
    // if (this.props.user.role_id > 0) {
    //   columns.splice(2,0,{
    //     Header: "Subaffiliates",
    //     accessor: "subaffiliate",
    //     minWidth: 120,
    //     style: {overflow: "auto"},
    //     className: "text-center",
    //     Cell: props => <div>{props.value}</div>,
    //     sortable: false
    //   })
    // }
    // if (parseInt(this.props.user.aid) == 10111 || parseInt(this.props.user.owner_wid) == 10111) {
    //   columns.splice(1,0,{
    //     Header: "Signups",
    //     id: "signups",
    //     accessor: d => parseInt(d.signups) || 0,
    //     minWidth: 50,
    //     sortable: false,
    //     className: "text-center",
    //     Footer: props => <span>{this.props.total.signups || 0}</span>
    //   })
    // }
    if (this.props.user.autologin == 1) {
      columns.splice(1, 0, {
        Header: 'Visits',
        id: 'visits',
        accessor: (d) => parseInt(d.visits) || 0,
        minWidth: 50,
        // sortable: false,
        className: 'text-center',
        visible: false,
        Footer: (props) => <span>{this.props.total.visits || 0}</span>
      });
    }
    if (
      parseInt(this.props.user.cupid) === 1 ||
      parseInt(this.props.user.hgh2) === 1 ||
      parseInt(this.props.user.dgold) === 1 ||
      parseInt(this.props.user.punk) === 1 ||
      parseInt(this.props.user.punk1) === 1 ||
      parseInt(this.props.user.loc) === 1
    ) {
      columns.splice(3, 0, {
        Header: 'Leads',
        id: 'trials',
        accessor: (d) => parseInt(d.trials) || 0,
        minWidth: 50,
        // sortable: false,
        className: 'text-center',
        Footer: (props) => <span>{this.props.total.trials || 0}</span>
      });
      columns.splice(4, 0, {
        Header: 'Rate, %',
        id: 'trials_clicks',
        accessor: (d) => {
          let clicks = parseInt(this.props.total.uniq_visits) || 0;
          let trials = parseInt(d.trials) || 0;
          return clicks > 0 ? ((trials / clicks) * 100).toFixed(2) : '-';
        },
        minWidth: 50,
        // sortable: false,
        className: 'text-center',
        Footer: (props) => <span>{this.props.total.trials || 0}</span>
      });
    }
    return columns;
  };

  apiPath = 'affiliate/sales_date';

  tableParams = {
    manual: false,
    defaultPageSize: 30,
    showPagination: false,
    sorted: [
      {
        id: 'date2',
        desc: true
      }
    ],
    showAll: true
  };
  addDay = false;

  fetchParams = (state) => {
    return {
      subaffiliate: this.props.state.affiliate || '',
      offer: this.props.state.offer,
      load_all: true
    };
  };

  changeOffer = (e) => {
    this.props.setState({
      offer: e.target.value
    });
  };

  render() {
    let offers = this.offers.filter(
      (offer) => offer.value == 'all' || this.props.user[offer.value] == 1
    );
    return (
      <div class='co__date-sales'>
        <div class='row co__table-filters'>
          <div class='col-3'>
            <div class='btn-group w-100'>
              {this.typeButton('Day', 'daily', 'col-4')}
              {this.typeButton('Week', 'weekly', 'col-4')}
              {this.typeButton('Month', 'monthly', 'col-4')}
            </div>
          </div>
          <div class='col-2'>
            {this.props.subaffiliates.length > 0 && (
              <select
                class='form-control form-control-sm'
                name='affiliate'
                value={this.props.state.affiliate || ''}
                onChange={this.changeType}
              >
                <option value='0'>All</option>
                {this.props.subaffiliates.map((item) => {
                  return (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  );
                })}
              </select>
            )}
          </div>
          <div class='col-2'>
            <select class='form-control form-control-sm' onChange={this.changeType} name='offer'>
              {offers.map((offer) => (
                <option key={offer.value} value={offer.value}>
                  {offer.name}
                </option>
              ))}
            </select>
          </div>
          <div class='col-5'>
            <div class='pull-right'>
              {this.datepickerElement({ small: false, format: 'D MMM YYYY' })}
            </div>
          </div>
        </div>
        <div class='row mt-2'>
          <div class='col-12'>
            <div>{this.reactTable()}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(Component, 'affiliate_sales_date');
